import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchAllCategories } from "./../../actions/categories/fetchAllCategories";
import { showModal } from "./../../actions/categories/showModal";
import { showLoader } from "./../../actions/categories/showLoader";
import { isEdited } from "./../../actions/categories/isEdited";
import API from "./../../Constants/categories/API"
import * as categoryServices from "../../services/categories/index"
import moment from 'moment';
import { Dimmer, Loader, Image, Segment } from 'semantic-ui-react'

var userDetails = atob(localStorage.getItem("userDetails"));
if (userDetails) {
    try {
        userDetails = JSON.parse(userDetails);
    }
    catch (error) {
        console.error('Invalid JSON input:', error.message);
    }
}

//console.log("userDetails", userDetails);
//let userDetails;
var loggedInUserId = userDetails ? userDetails.UserContext.userId : 16194;
var firmID = userDetails ? userDetails.UserContext.firmId : 697;

class TaskCount extends Component {

  constructor(props) {
    super(props)

    this.state = {
      taskCount: null
    }
  }

  componentDidMount() {
    const firmId = firmID;
    /* 
      Finding the category Id
      - HOT rowNumber => this.props.payload.data[0][0] + 1
      - Find the cat_order in this.props.categories  for cat_id
    */
    const catId = this.props.categories.filter((elem) => {
      return elem.cat_Order === this.props.payload.data[0][0] + 1
    })[0].category_id

    async function getTaskCountAsync(firmId, catId) {
      let response = await categoryServices.req.getTaskCount(API.getTaskCount, firmId, catId);
      return response;
    }

    getTaskCountAsync(firmId, catId).then((res) => {
      this.setState({
        taskCount: res
      })
    })

  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    //console.log("component Did update - TaskCount.js")
    if (this.props.submit) {
      this.handleSubmit();
    }
    this.setModalSubStateToFalse();
  }

  setModalSubStateToFalse = () => {
    this.props.setFalse(false);
  }

  handleSubmit() {
    //console.log("handleSubmit - Taskcount.js", this.props.submit, this.props.payload, this.props.categories, this.props.hotInstanceProps);

    const todayDate = moment().format("MM/DD/YY")
    const loggedInUserName = "ZZ- XCM Web,Administrator"

    // Set Cell Colors
    this.props.hotInstanceProps.current.hotInstance.setDataAtCell(this.props.payload.data[0][0], 6, todayDate);
    this.props.hotInstanceProps.current.hotInstance.setDataAtCell(this.props.payload.data[0][0], 7, loggedInUserName);
    this.props.hotInstanceProps.current.hotInstance.setCellMeta(this.props.payload.data[0][0], 6, "className", "editedCellColor");
    this.props.hotInstanceProps.current.hotInstance.setCellMeta(this.props.payload.data[0][0], 7, "className", "editedCellColor");

    // changing the props directly in state , instead of settign as data in HOT
    this.props.categories.map((elem) => {
      if (elem.cat_Order == this.props.payload.data[0][0] + 1) {
        elem.is_active = false;
        return elem
      } else {
        return elem;
      }
    })
    this.props.changedRows([{
      row: this.props.payload.data[0][0],
      col: 6
    }, {
      row: this.props.payload.data[0][0],
      col: 7
    }]);

    //console.log("CHANGED ROW TO BE EFF",this.props.categories.map(elem => elem.cat_Order == this.props.payload.data[0][0] + 1))
    this.props.isEdited(true)
    this.props.showModal({
      state: false,
      modalName: "Confirm your action",
      component: "TASK_COUNT",
      size: "small",
      submitBtn: "Yes",
      denyBtn: "No",
      payload: {}
    });

  }

  render() {
    if (this.state.taskCount !== null) {
      // {this.props.showLoader(false)}
      return (
        <div>
           There are {this.state.taskCount} active tasks associated with this Category. Are you sure you would like to hide the Category?
            </div>
      )
    } else {
      // {this.props.showLoader(true)}
      return (<div>
        <Dimmer active inverted>
          <Loader inverted content='Loading' />
        </Dimmer>
        <Image height="90" src='https://react.semantic-ui.com/images/wireframe/short-paragraph.png' />
      </div>)
    }

  }
}

function mapStateToProps(state) {
  //console.log("from mapStateToProps", state);
  return {
    categories: state.allCategories.categories,
    edited: state.allCategories.edited
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { fetchAllCategories, showModal, isEdited, showLoader },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskCount);